import { Auth } from "aws-amplify";
import { LogOut } from "lucide-react";
import { Separator } from "@hotelise/ui";

interface Props {
	isExpanded: boolean;
}

const LogOutButton = ({ isExpanded }: Props): JSX.Element => {
	const handleLogout = async () => {
		try { await Auth.signOut(); } catch { /* already signed out */ }
		window.location.href = '/';
	};

	return (
		<div>
			<Separator className="mb-2" />
			<button
				type="button"
				onClick={handleLogout}
				className="flex items-center gap-3 w-full p-3 rounded-lg text-destructive hover:bg-destructive/10 transition-colors cursor-pointer"
			>
				<LogOut
					className={`shrink-0 h-5 w-5 ${isExpanded ? "" : "mx-auto"}`}
				/>
				{isExpanded && <span className="text-sm font-medium">Log Out</span>}
			</button>
		</div>
	);
};

export default LogOutButton;
